const NA = 'N/A';

function isYearMissing(year: number | string | null | undefined): boolean {
  if (year === null || year === undefined) return true;
  if (typeof year === 'number' && (year === 0 || Number.isNaN(year))) return true;
  const ys = String(year).trim();
  return ys === '' || ys.toLowerCase() === 'null';
}

function isTextMissing(value: string | number | null | undefined): boolean {
  if (value === null || value === undefined) return true;
  const s = String(value).trim();
  if (s === '' || s.toLowerCase() === 'null') return true;
  const lower = s.toLowerCase();
  return lower === '-' || lower === 'n/a' || lower === 'na' || lower === 'none' || lower === '--';
}

/**
 * Single-line vehicle label for lists.
 * If year, make, or model is missing, returns a single "N/A" (no partial strings like "2026" alone).
 */
export function formatVehicleLine(
  year: number | string | null | undefined,
  make: string | number | null | undefined,
  model: string | number | null | undefined
): string {
  if (isYearMissing(year) || isTextMissing(make) || isTextMissing(model)) {
    return NA;
  }
  const y = typeof year === 'number' ? String(year) : String(year).trim();
  return `${y} ${String(make).trim()} ${String(model).trim()}`;
}
